import { Avatar, Badge, Text, tooltip } from '@prismeet/react'
import { useLocation, useNavigate } from 'react-router'

import { ROUTES } from '@/app/router/constants'
import { useAppUiStore } from '@/shared/stores/appUiStore'

import { RAIL_LABEL, SURFACES } from './constants'
import styles from './index.module.scss'

/**
 * Рельс переключения микрофронтов.
 *
 * Самый верхний уровень навигации: не «раздел», а какая половина продукта
 * открыта. Каждый пункт — отдельный микрофронт из отдельного репозитория,
 * и переход между ними должен читаться как переход между приложениями,
 * а не как ещё один пункт меню.
 */
export function AppRail() {
  const navigate = useNavigate()
  const location = useLocation()
  const unreadBySpace = useAppUiStore((state) => state.unreadBySpace)
  const setActiveSurface = useAppUiStore((state) => state.setActiveSurface)

  const isSpaces =
    location.pathname.startsWith(ROUTES.messages) || location.pathname.startsWith('/spaces')
  const activeId = isSpaces ? 'spaces' : 'social'

  const spacesUnread = Object.values(unreadBySpace).reduce((sum, value) => sum + value, 0)

  return (
    <nav className={styles.rail} aria-label={RAIL_LABEL}>
      {SURFACES.map((surface) => {
        const active = surface.id === activeId
        const unread = surface.id === 'spaces' ? spacesUnread : 0

        return (
          <button
            key={surface.id}
            type="button"
            className={styles.railButton}
            data-active={active}
            aria-current={active ? 'page' : undefined}
            onClick={() => {
              setActiveSurface(surface.id)
              void navigate(surface.route)
            }}
            {...tooltip(`${surface.label} — ${surface.hint}`)}
          >
            {active ? <span className={styles.railIndicator} aria-hidden="true" /> : null}
            <Avatar
              name={surface.label}
              shape="rounded"
              size="md"
              labelledOutside
              fallback={
                <Text variant="label" weight="bold" tone="inherit">
                  {surface.label.slice(0, 1)}
                </Text>
              }
            />
            {unread > 0 ? (
              <span className={styles.railBadge}>
                <Badge count={unread} tone="accent" label="непрочитанных" />
              </span>
            ) : null}
            <span className="visually-hidden">{surface.label}</span>
          </button>
        )
      })}
    </nav>
  )
}
